// equal_height_fit-rows.js
export function applyEqualHeightFitRowsPatch(IsotopeReference) {
    'use strict';

    if (typeof IsotopeReference === 'undefined' || typeof IsotopeReference.LayoutMode === 'undefined' || typeof IsotopeReference.LayoutMode.modes.fitRows === 'undefined') {
        console.warn("Isotope or its 'fitRows' layout mode not found. Equal height patch not applied. (Passed reference was:", IsotopeReference, ")");
        return;
    }

    const OriginalFitRows = IsotopeReference.LayoutMode.modes.fitRows;
    const OriginalGetItemLayoutPosition = OriginalFitRows.prototype._getItemLayoutPosition;
    var FitRows = IsotopeReference.LayoutMode.modes.fitRows;

    function getEqualHeightOption(options) {
        const optionValue = (options && options.fitRows && typeof options.fitRows.equalheight !== 'undefined') ? options.fitRows.equalheight :
            (options && typeof options.equalheight !== 'undefined') ? options.equalheight :
                false;
        return optionValue;
    }

    FitRows.prototype._resetLayout = function() {
        this.x = 0;
        this.y = 0;
        this.maxY = 0;
        this.row = 0;
        this.rows = [];

        if (getEqualHeightOption(this.options)) {
            for (var i = 0; i < this.items.length; i++) {
                var itemElement = this.items[i].element;
                var innerShadow = itemElement.querySelector('.shadow');
                if (innerShadow) {
                    innerShadow.style.height = '';
                } else {
                    itemElement.style.height = '';
                }
            }
        }
        this._getMeasurement('gutter', 'outerWidth');
    };

    FitRows.prototype._getItemLayoutPosition = function(item) {
        return OriginalGetItemLayoutPosition.apply(this, arguments);
    };

    FitRows.prototype._equalHeight = function() {
        if (!getEqualHeightOption(this.options)) return;

        const rowsGroupedByY = {};
        const Y_TOLERANCE = 1;

        for (const item of this.items) {
            const itemY = item.position.y;
            let foundRow = false;
            for (const yCoord in rowsGroupedByY) {
                if (Math.abs(itemY - parseFloat(yCoord)) < Y_TOLERANCE) {
                    rowsGroupedByY[yCoord].push(item);
                    foundRow = true;
                    break;
                }
            }
            if (!foundRow) {
                rowsGroupedByY[itemY] = [item];
            }
        }

        for (const yCoord in rowsGroupedByY) {
            const rowItems = rowsGroupedByY[yCoord];
            let maxHeight = 0;

            for (var j = 0; j < rowItems.length; j++) {
                var itemElement = rowItems[j].element;
                var innerShadow = itemElement.querySelector('.shadow');
                let currentHeight = 0;

                if (innerShadow) {
                    // Höhe ohne Margin
                    currentHeight = innerShadow.getBoundingClientRect().height;
                } else {
                    currentHeight = itemElement.getBoundingClientRect().height;
                }

                maxHeight = Math.max(maxHeight, currentHeight);
            }

            for (var k = 0; k < rowItems.length; k++) {
                var itemElementToSet = rowItems[k].element;
                var innerShadowToSet = itemElementToSet.querySelector('.shadow');
                if (innerShadowToSet) {
                    innerShadowToSet.style.height = maxHeight + 'px';
                } else {
                    itemElementToSet.style.height = maxHeight + 'px';
                }
                rowItems[k].getSize();
            }
        }
    };

    FitRows.prototype._getContainerSize = function() {
        this._equalHeight();
        return { height: this.maxY };
    };
}
